import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCarousel,
    _vm._g(
      _vm._b(
        {
          ref: "itemSlide",
          staticClass: "border",
          attrs: { "hide-delimiters": "" },
          on: { change: _vm.changeSlide },
          model: {
            value: _vm.current,
            callback: function ($$v) {
              _vm.current = $$v
            },
            expression: "current",
          },
        },
        "v-carousel",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    _vm._l(_vm.getValue, function (item, index) {
      return _c(VCarouselItem, { key: `carousel-item-${index}` }, [
        item["mimetype"] === false
          ? _c(
              "div",
              { staticClass: "slide-container" },
              [
                _c("ImageWrapper", {
                  staticClass: "align-center ma-3",
                  attrs: {
                    contain: "",
                    src: require(`@/assets/images/icons/image-broken-variant.svg`),
                    "max-height": "95%",
                    "max-width": "95%",
                  },
                }),
              ],
              1
            )
          : item["mimetype"] !== undefined
          ? _c("div", { staticClass: "slide-container" }, [
              item["mimetype"].startsWith("image")
                ? _c(
                    "div",
                    { staticClass: "slide-item-wrapper" },
                    [
                      _c("ImageWrapper", {
                        attrs: {
                          contain: "",
                          src: item.src,
                          "max-height": "100%",
                          "max-width": "100%",
                        },
                      }),
                    ],
                    1
                  )
                : item["mimetype"].startsWith("video")
                ? _c(
                    "div",
                    { staticClass: "slide-item-wrapper" },
                    [
                      _c(
                        "vue-plyr",
                        {
                          key: _vm.videoKey,
                          ref: `media-plyr-${index}`,
                          refInFor: true,
                          attrs: {
                            options: {
                              ..._vm.plyrVideoOptions,
                              i18n: _vm.plyrLocale,
                            },
                          },
                        },
                        [
                          _c("video", {
                            attrs: {
                              src: item.src,
                              controls: "",
                              crossorigin: "",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : item["mimetype"].startsWith("audio")
                ? _c(
                    "div",
                    { staticClass: "slide-item-wrapper" },
                    [
                      _c(
                        "vue-plyr",
                        {
                          key: _vm.audioKey,
                          ref: `media-plyr-${index}`,
                          refInFor: true,
                          attrs: {
                            options: {
                              ..._vm.plyrAudioOptions,
                              i18n: _vm.plyrLocale,
                            },
                          },
                        },
                        [
                          _c("audio", {
                            attrs: {
                              src: item.src,
                              controls: "",
                              crossorigin: "",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : item["mimetype"].startsWith("youtube")
                ? _c(
                    "div",
                    { staticClass: "slide-item-wrapper" },
                    [
                      _c(
                        "vue-plyr",
                        {
                          key: _vm.videoKey,
                          ref: `media-plyr-${index}`,
                          refInFor: true,
                          attrs: {
                            options: {
                              ..._vm.plyrVideoOptions,
                              i18n: _vm.plyrLocale,
                            },
                          },
                        },
                        [
                          _c("iframe", {
                            attrs: {
                              id: `youtube-video-${_vm.videoKey}-${index}`,
                              src: item.src,
                              title: "YouTube video player",
                              frameborder: "0",
                              allow:
                                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                              allowfullscreen: "",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "slide-item-wrapper item-document" },
                    [
                      _c("ImageWrapper", {
                        staticClass: "align-center ma-3",
                        attrs: {
                          contain: "",
                          src: _vm.document_poster,
                          "max-height": "95%",
                          "max-width": "95%",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.hideDocumentName
                        ? _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "text-left document-item text-h5",
                                                class: {
                                                  color: `${_vm.textColor}--text`,
                                                },
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(item.name) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.name))]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ])
          : _vm._e(),
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }